var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-4",staticStyle:{"height":"40vh"}},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('canvas',{attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }